import { ApplicantMinorV2Dto, ApplicationV2Dto } from '@inosio/payments-sdk';
import { Box } from '@mui/system';
import ApplicationDetailsApplicantEntityData, { ApplicantEntityDataTableField } from './ApplicationDetailsApplicantEntityData';
import { Typography, Divider, Accordion, AccordionSummary, Grid, AccordionDetails } from '@mui/material';
import { handleBuildCustomQuestionDataTable } from './helpers';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getDurationBetweenTwoDates } from '../../../../shared/util/formaters';
import { convertSqlDateToUSCalendarDate } from '../../../../shared/util/converters';

export interface ApplicationDetailsGeneralProps {
  application: ApplicationV2Dto;
}
export default function ApplicationDetailsMinors(props: ApplicationDetailsGeneralProps) {
  const allApplicantsOnThisApplication = [...(props.application.CoApplicants || []), props.application.PrimaryApplicant];

  const allMinorsOnThisApplication = allApplicantsOnThisApplication.flatMap((applicant) => applicant.Minors || []);

  const handleBuildMinorsData = (thisMinor: ApplicantMinorV2Dto | undefined) => {
    const minorsData: ApplicantEntityDataTableField[] = [
      {
        label: 'Full Name',
        value: (thisMinor?.FirstName || '') + ' ' + (thisMinor?.MiddleName || '') +' ' + (thisMinor?.LastName || ''),
      },
      {
        label: 'DOB',
        value: thisMinor?.Dob ? convertSqlDateToUSCalendarDate(thisMinor?.Dob) : '',
      },
    ];

    const customQuestionsForPersonalInfo: ApplicantEntityDataTableField[] = handleBuildCustomQuestionDataTable(thisMinor?.CustomQuestionsAnswers || []);

    return [...minorsData, ...(customQuestionsForPersonalInfo || [])];
  };

  return (
    <Box
      sx={{
        width: '100%',
        overflow: 'auto',
        padding: 2,
        height: 'calc( 100vh - 294px )',
        '&::-webkit-scrollbar': {
          width: 7,
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
          borderRadius: '24px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: 'darkgrey',
          borderRadius: '24px',
        },
      }}
    >
      <Typography sx={{ fontFamily: 'Work Sans !important', fontWeight: 'bold', marginBottom: 1 }}>Minor Occupants:</Typography>
      <Divider sx={{ marginY: 1, borderBottomWidth: 1, backgroundColor: 'black' }} />

      {allMinorsOnThisApplication?.length ? (
        allMinorsOnThisApplication?.map((minor) => {
          const parentOccupant = allApplicantsOnThisApplication.find((app) => app.Uuid === minor.ParentOccupantUuid);
          return (
            <Accordion sx={{ marginTop: 2 }} elevation={0} key={minor.Uuid}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ marginTop: 2, boxShadow: 'none', '& .MuiPaper-root': { boxShadow: 'none' } }}>
                <Grid container sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                  <Grid item xs={4}>
                    <Typography sx={{ fontFamily: 'Work Sans !important' }}>{(minor?.FirstName || '') + ' ' + (minor?.MiddleName || '') +' ' + (minor?.LastName || '')}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontFamily: 'Work Sans !important' }}>{minor.Dob ? getDurationBetweenTwoDates(minor.Dob, new Date().toISOString()) : ''}</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontFamily: 'Work Sans !important' }}>{(parentOccupant?.FirstName || '') + ' ' + (parentOccupant?.MiddleName || '') + ' ' + (parentOccupant?.LastName || '')}</Typography>
                  </Grid>
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <ApplicationDetailsApplicantEntityData tableData={handleBuildMinorsData(minor)} />
              </AccordionDetails>
            </Accordion>
          );
        })
      ) : (
        <Grid container sx={{ display: 'flex', alignItems: 'center', width: '100%', mt: 2 }}>
          <Grid item xs={12}>
            <Typography sx={{ fontFamily: 'Work Sans !important' }}>Applicants have indicated there are no minor occupants.</Typography>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}
